import ClassNames from "classnames";
import * as React from "react";

import Button from "../Button";
import Styles from "./ButtonIcon.module.css";

export interface Props {
  label: string;
  icon: JSX.Element;
  variant?: "solid" | "outlined" | "text";
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  shape?: "circle" | "square";
  size?: "small" | "medium" | "large";
}

const ButtonIcon: React.FC<Props> = props => {
  const {
    variant = "solid",
    className,
    disabled,
    loading,
    icon,
    onClick,
    label,
    shape = "circle",
    size = "small"
  } = props;

  return (
    <Button
      variant={variant}
      className={ClassNames({
        [Styles.buttonIcon]: true,
        [Styles[size]]: true,
        [Styles[shape]]: true,
        [className]: className
      })}
      disabled={disabled}
      ariaLabel={label}
      onClick={onClick}
      loading={loading}
    >
      {icon}
    </Button>
  );
};

export default ButtonIcon;
